import { MutationCache, QueryClient } from "@tanstack/react-query"

import { toast } from "@atlant/ui"

import { GraphQLClientError } from "#utils/graphql-client.ts"

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error) => {
      const path =
        error instanceof GraphQLClientError ? error.response.errors[0]?.path : null
      toast.error(error.message, { description: path?.join(".") })
    },
  }),
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: Infinity,
    },
  },
})
